import { Divider, Modal, Select } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import SelectProductItemsHeader from "./header/SelectProductItemsHeader";
import SelectProductItemsMain from "./main/SelectProductItemsMain";
import classes from "./SelectProductItemsModal.module.scss";
import { backColorModal, foreColorCode } from "../../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
import { User } from "../../types/user";
type Props = {
  setIsShow: (value: boolean) => void;
};

const SelectProductItemsModal: FC<Props> = (props) => {
  const { setIsShow } = props;
  const user = useRecoilValue<User>(userState);
  const [open, setOpen] = useState<boolean>(true);
  const [checkedItems, setCheckedItems] = useState<Number[]>(
    user.filters.productItem
  );
  const handleOnClose = () => {
    setOpen(false);
    setIsShow(false);
  };
  // useEffect(() => {
  //   console.log("checkedItems", checkedItems, checkedItems.length);
  // }, [checkedItems]);
  return (
    <Modal
      open={open}
      onClose={handleOnClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: "prmary.main",
        border: "none",
        "&:focus-visible": {
          borderColor: "prmary.main",
          outlineColor: "primary.main", // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div
        className={classes.rootContainer}
        style={backColorModal(user?.mode ?? "lite")}
      >
        <SelectProductItemsHeader
          setIsShow={setIsShow}
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
        />
        <Divider
          textAlign="left"
          sx={dividerStyle(
            user?.mode === "lite"
              ? foreColorCode("lite")
              : foreColorCode("dark")
          )}
          variant="fullWidth"
        ></Divider>
        <SelectProductItemsMain
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
        />
      </div>
    </Modal>
  );
};
const dividerStyle = (color: string) => {
  let styles = {
    borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
    fontSize: "18px",
    marginBottom: "0px",
    // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
    "&::before, &::after": {
      // Dividerの線のスタイルをカスタマイズ
      borderTopColor: `${color}`, // これにより、線の色が変わります
    },
    color: `${color}`, // テキストの色を変更
    "@media (max-width: 600px)": {
      fontSize: "14px", // フォントサイズを14pxに設定
    },
  };
  return styles;
};

export default SelectProductItemsModal;
